module.exports = __webpack_public_path__ + "img/unit_SilverMetallic.42e04b2d.png";